export interface ITeamLeadAPIResponse {
  collectionCaseId: number;
  customerId: string;
  customerName: string;
  phoneNumber: string;
  accountNumber: string;
  feedbackType: string;
  feedbackDate: string;
  pinCode: string;
  city: string;
  state: string;
  outStandingAmount: number;
  currentDPD: number;
  dpdBucket: string;
  agencyName: string;
  agentName: string;
  agentPhoneNumber: string;
  agentType: string;
  lastMonthEmiStatus: string;
  lastPaidDate: string;
  lastPaidEmiAmount: number;
}

export interface IPage {
  pageNo: number;
  totalPages: number;
  pageSize: number;
  totalElements: number;
  currentPageToken?: string;
  nextPageToken: string;
}

export interface queryParam {
  pageIndex?: string;
  pageSize?: string;
  pageNo?: string;
  sortBy?: string;
  sortDirection?: string;
  agencyCode?: string;
  agentType?: string;
  agentReferenceId?: string;
  riskIndicator?: string;
  interactionStatus?: string;
  riskSegments?: string;
  pinCodes?: string;
  accountNumbers?: string;
  dpdBuckets?: string;
  names?: string;
  queryType?: string;
  query?: string;
  lastUsed?: string;
  isIncludePageLookup?: string;
  agencyCodes?: string;
}

export interface filtersQueryParams {
  agencyCode?: string;
}

export const defaultQueryParam: queryParam = {
  pageSize: '50',
  pageNo: '0',
  sortBy: 'name',
  sortDirection: 'DESC',
  isIncludePageLookup: 'true'
};

export const TABLE_NAME = 'teamLead';

export interface ITeamLeadFilters {
  agentType: Array<keyof typeof AgentTypes>;
  interactionStatus: Array<keyof typeof InteractionStatus>;
  riskSegments: Array<keyof typeof CustomerProfile>;
  paymentStatus: Array<keyof typeof PaymentStatus>;
  agentReferenceId: {
    [key: string]: string;
  };
}

export interface ITeamLeadAPIReducer {
  teamLeadData: ITeamLeadAPIResponse[];
  page: IPage;
  loading: boolean;
  error: string;
  filters: ITeamLeadFilters;
}

export enum AgentTypes {
  FIELD = 'Field',
  CALLING = 'Calling',
  HUMAN_REMINDER = 'Human Reminder',
  SKIP_TRACING = 'Customer Outreach',
  FIELD_CALLING = 'Field Calling',
  LITE_CALLING = 'Lite Calling',
  BUFFER_CALLING = 'Buffer Calling',
  CENTRAL_UNIT_TRACING = 'Central Unit Tracing',
  CENTRAL_UNIT_TRACING_FIELD = 'Central Unit Tracing Field',
  NSA_CALLING = 'NSA Calling'
}

export enum CustomerProfile {
  HIGH_RISK = 'Red',
  MEDIUM_RISK = 'Orange',
  LOW_RISK = 'Green'
}

export enum InteractionStatus {
  PAID = 'Paid',
  PAID_ON_CALL = 'Paid On Call',
  PAID_ON_VISIT = 'Paid On Visit',
  PROMISE_TO_PAY = 'Promise to Pay',
  PTP_FROM_FRIENDS_OR_FAMILY = 'PTP from Friends or Family',
  REVISIT = 'Revisit',
  PROMISE_FULFILLED = 'Promise Fulfilled',
  BROKEN_PROMISE = 'Broken Promise',
  NOT_CONTACTABLE = 'Not Contactable',
  REQUESTED_CALLBACK = 'Requested Callback',
  CALLBACK = 'Callback',
  REQUESTED_VISIT = 'Requested Visit',
  FRAUD = 'Fraud',
  DISPUTE = 'Dispute',
  CUSTOMER_EXPIRED = 'Customer Expired',
  RINGING_NO_RESPONSE = 'Ringing No Response',
  ADDRESS_NOT_FOUND = 'Address Not Found',
  CUSTOMER_SHIFTED_FROM_ADDRESS = 'Customer Shifted from Address',
  REFUSED_TO_PAY = 'Refused to Pay',
  DOOR_LOCKED = 'Door Locked',
  CALL_DISCONNECTED_RPC = 'Call Disconnected RPC',
  CALL_DISCONNECTED_NON_RPC = 'Call Disconnected Non RPC',
  CALL_DISCONNECTED = 'Call Disconnected',
  MESSAGE_LEFT = 'Message Left',
  OTHERS = 'Others',
  SWITCHED_OFF = 'Switched Off',
  INVALID_NUMBER = 'Invalid Number',
  BUSY = 'Busy',
  PARTIALLY_PAID = 'Partially Paid',
  ENTRY_RESTRICTED = 'Entry Restricted',
  CUSTOMER_NEVER_LIVED_IN_ADDRESS = 'Customer Never Lived in Address',
  OUT_OF_NETWORK = 'Out of Network',
  CUSTOMER_NOT_IN_ADDRESS_AT_PRESENT = 'Customer Not in Address at Present',
  SETTLEMENT = 'Settlement',
  TPC_WRONG_NUMBER = 'TPC Wrong Number',
  TPC_UNKNOWN = 'TPC Unknown',
  NUMBER_PROVIDED = 'Number Provided',
  ADDRESS_PROVIDED = 'Address Provided',
  REQUESTED_LOAN_DETAILS = 'Requested Loan Details',
  WILLING_TO_PAY = 'Willing to Pay',
  DOES_NOT_KNOW_CUSTOMER = 'Does Not Know Customer',
  PICKED_UP_DISCONNECTED = 'Picked Up Disconnected',
  LANGUAGE_BARRIER = 'Language Barrier',
  TECHNICAL_ERROR = 'Technical Error',
  NONE_OF_THE_ABOVE = 'None of the Above',
  FORECLOSURE = 'Foreclosure',
  ACCOUNT_UNAVAILABLE = 'Account Unavailable',
  REFUSED_TO_PAY_PENALTY = 'Refused to Pay Penalty',
  PAUSE_AMEYO = 'Pause Ameyo',
  REFUSED_TO_COOPERATE = 'Refused to Cooperate',
  MISSED_CALL = 'Missed Call',
  ESCALATION_THREAT = 'Escalation Threat',
  POTENTIAL_BOUNCE = 'Potential Bounce',
  UNKNOWN = 'Unknown',
  IVR = 'IVR',
  REQUESTED_MANDATE_PRESENTATION = 'Requested Mandate Presentation',
  REFUSE_TO_PAY = 'Refuse to Pay',
  REQUESTED_PENALTY_HOLD = 'Requested Penalty Hold',
  PAYMENT_CLAIM = 'Payment Claim',
  PAY_LATER = 'Pay Later'
}

export enum PaymentStatus {
  ALL = 'All',
  PAID = 'Paid',
  UNPAID = 'Unpaid',
  PARTIALLY_PAID = 'Partially Paid'
}

export const FiltersKeys = [
  {
    key: 'agentType',
    label: 'Agent Type'
  },
  {
    key: 'interactionStatus',
    label: 'Interaction Status'
  },
  {
    key: 'riskSegments',
    label: 'Customer Profile'
  },
  {
    key: 'paymentStatus',
    label: 'Payment Status'
  },
  {
    key: 'agentReferenceId',
    label: 'Agent Name'
  }
];

export const enumMapping = {
  agentType: AgentTypes,
  interactionStatus: InteractionStatus,
  paymentStatus: PaymentStatus,
  riskSegments: CustomerProfile
};

export interface ISelectedFilters {
  agentType?: {
    [key: string]: boolean;
  };
  interactionStatus?: {
    [key: string]: boolean;
  };
  paymentStatus?: {
    [key: string]: boolean;
  };
  agentReferenceId?: {
    [key: string]: boolean;
  };
  riskSegments?: {
    [key: string]: boolean;
  };
}
